import { useFlags } from "launchdarkly-react-client-sdk";
import { Navigate } from "react-router-dom";

import Breadcrumb from "components/atoms/Breadcrumb";
import Container from "components/atoms/Container";
import DetailsNutritionPlatform from "components/organisms/Details/DetailsNutritionPlatform";
import NavHeader from "components/organisms/NavHeader";

import { NUTRITION_PLATFORM_SLUG, isValidProduct } from "utils/products";

const Details = () => {
  const flags = useFlags();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const productQuery = params.get("product");

  if (!productQuery) {
    return <Navigate to="/" />;
  }
  if (!isValidProduct(productQuery)) {
    return <Navigate to="/not-found" />;
  }

  // Only Nutrition AI Platform has a details page. Any other product slug
  // (legacy Hub, Mobile AI, Nutrition AI/API/Advisor, Remodel AI, VR
  // Showroom, Tiered AI Hub) redirects to the dashboard.
  if (productQuery !== NUTRITION_PLATFORM_SLUG) {
    return <Navigate to="/" />;
  }
  if (!flags["nutrition-ai-platform"]) {
    return <Navigate to="/" />;
  }

  const pageList = [
    {
      label: "All Products",
      path: "/",
    },
    {
      label: "Manage Subscription",
      path: `/manage-subscription?product=${productQuery}`,
    },
    {
      label: "Product Details",
    },
  ];

  return (
    <NavHeader>
      <Container>
        <Breadcrumb pageList={pageList} />
        <DetailsNutritionPlatform />
      </Container>
    </NavHeader>
  );
};

export default Details;
